import React from 'react';
import { List, Icon, Button, Avatar } from 'antd';
import PropTypes from 'prop-types';
import ConnectionTile from './ConnectionTile';

class ConnectionList extends React.Component {
  render() {
    const { connections, activeId, onSelect, onEdit } = this.props;

    const activeConnection = connections.filter(connection => connection.id === activeId).pop();
    const filteredConnections = connections.filter(connection => connection.id !== activeId);

    return (
      <React.Fragment>
        {activeConnection && (
          <List
            key="active"
            itemLayout="vertical"
            size="large"
            style={{
              position: 'sticky',
              top: 0,
              zIndex: '1',
            }}
          >
            <ConnectionTile
              key="active"
              connection={activeConnection}
              isActive={activeId === activeConnection.id}
              onSelect={onSelect}
              onEdit={onEdit}
            />
          </List>
        )}
        {!!(!activeConnection || filteredConnections.length) && (
          <List
            key="list"
            itemLayout="vertical"
            size="large"
            split={false}
            dataSource={connections.filter(connection => connection.id !== activeId)}
            renderItem={connection => (
              <ConnectionTile
                connection={connection}
                isActive={activeId === connection.id}
                onSelect={onSelect}
                onEdit={onEdit}
              />
            )}
          />
        )}
      </React.Fragment>
    );
  }
}

ConnectionList.propTypes = {
  connections: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
  activeId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default ConnectionList;
